import React from "react";
import { TChecklistItemResolvedByParty } from "../../../../../domain/codecs/ChecklistItemResolvedByParty";

const partyLabel: Record<TChecklistItemResolvedByParty, string> = {
    client: "Client",
    conveyancer: "Us",
    third_party: "Third party",
    us: "Us",
    seller: "Seller",
    buyer: "Buyer",
    supplier: "Supplier",
    portal: "Portal",
};

export const CRMRoadblockPartyPill = (props: { party: TChecklistItemResolvedByParty }): JSX.Element =>
    <div className={`crm-roadblock-party-pill crm-roadblock-party-pill--${props.party}`}>
        {partyLabel[props.party]}
    </div>;
